import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'redux-store/store';
import App from 'app/App';
import * as serviceWorker from 'serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'styles/react-datetime.css';
import 'styles/buttons.css';
import 'styles/base.css';
import 'styles/alert.css';


render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
